import * as React from 'react';
import { useSelector } from 'react-redux';

import { CallbackRequestBlock } from 'shared/components/CallbackRequestBlock';
import { CardSectionNew } from 'shared/components/CardSectionNew';
import { getIsCallbackAvailable } from 'shared/selectors';
import { selectNewbuildingBrokerOfferBookingEnabled } from 'shared/selectors/featureToggle';
import { selectMessageButtonAvailable } from 'shared/selectors/messageButton';

import { CallBackButtonContainer } from '../CallBackButton';

export const CallbackRequestBlockContainer = () => {
  const isMessageButtonAvailable = useSelector(selectMessageButtonAvailable);
  const isCallbackAvailable = useSelector(getIsCallbackAvailable);
  const isOfferBookingEnabled = useSelector(selectNewbuildingBrokerOfferBookingEnabled);

  // TODO: В CD-235461 после запуска проекта бронирования оставить только условие isCallbackAvailable.
  if ((!isMessageButtonAvailable && !isOfferBookingEnabled) || !isCallbackAvailable) {
    return null;
  }

  return (
    <CardSectionNew hideForPrint>
      <CallbackRequestBlock
        callbackButton={
          <CallBackButtonContainer
            placeType="floating_block"
            buttonTheme="fill_primary"
            callbackButtonText="Заказать звонок"
          />
        }
      />
    </CardSectionNew>
  );
};
